import React from 'react';
import styled from 'styled-components';

import { Flex } from 'src/packages/core';
import { hexToRGBA } from 'src/utils/hex-to-rgba';

require('react-datepicker/dist/react-datepicker.css');

export const DateRangeWrapper = styled((props) => <Flex {...props} />)`
  ${({ defaulttheme: { colors, typographyScale, mediaQueries }, themetype }) => `
    .react-datepicker-wrapper {
      width: inherit;
      height: fit-content;
    }
    
    .react-datepicker {
      background: ${colors.background.secondary.BG3};
      border: 0;
      .react-datepicker__triangle::after, .react-datepicker__triangle::before {
        border-bottom-color: ${colors.background.secondary.BG3};
      }
      .react-datepicker__header {
        background: transparent;
        border-bottom-color: ${colors.border.middle};
      }
      .react-datepicker__current-month, .react-datepicker__day-name, .react-datepicker__day {
        color: ${colors.text.primary};
      }
      .react-datepicker__day:hover{
        background-color: ${colors.palette.primary};
        color: ${themetype === 'light' ? colors.palette.white : colors.palette.black};
      }
      .react-datepicker__navigation-icon::before {
        border-color: ${colors.text.primary};
      }
      .react-datepicker__day--in-range, .react-datepicker__day--in-selecting-range{
        background-color: ${hexToRGBA(colors.palette.primary, 0.25)};
      }
      .react-datepicker__day--range-end, 
      .react-datepicker__day--range-start, 
      .react-datepicker__day--keyboard-selected{
        background-color: ${colors.palette.primary};
        color: ${themetype === 'light' ? colors.palette.white : colors.palette.black};
        font-weight: normal;
      }
    }

    .date-ranger-picker-input{
      input{
        min-width: 230px;
        font-size:${typographyScale.desktop.p2.fontSize};
        line-height:${typographyScale.desktop.p2.lineHeight};
        font-family:${typographyScale.desktop.p2.fontFamily};
        font-weight:${typographyScale.desktop.p2.fontWeight};
        color: ${colors.text.primary};
        direction: ltr;
        &:placeholder {
          color:${colors.text.secondary};
          font-size: inherit;
        }
      }
      svg {
        height:16px;
        width:16px;
      }
    }
    ${mediaQueries.md} {
      .react-datepicker__month-container{
        width:-webkit-fill-available;
      }
    }
  `}
`;
